import React from 'react';
import { useEffect, useState } from 'react';
import './QueueHeader.css';
import { EXTENDED_HEADER_HEIGHT, MOBILE_MEDIUM_HEADER_HEIGHT } from '../../constants';
import { useNavigate } from 'react-router-dom';

export function QueueHeader({ handleToggleAllMinimize, isAllMinimized }) {
    const navigate = useNavigate();
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const handleGoToFeed = () => {
        navigate('/feed')
    }

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (
        <>
            {windowWidth > 768 ? (
                <div className="header" style={{ height: `${EXTENDED_HEADER_HEIGHT}px` }}>
                    <div className="queueHeaderContents">
                        <h1 className="queueTitle" onClick={handleGoToFeed}>Lava
                            <img className="queueTitleLogo" src={require('../../assets/images/logo-white.png')} />
                            amp
                        </h1>
                        <button className={`minimizeButton`} onClick={handleToggleAllMinimize}>{isAllMinimized ? 'Maximize All' : 'Minimize All'}</button>
                    </div>
                </div>
            ) : (
                <div className="header" style={{ height: `${MOBILE_MEDIUM_HEADER_HEIGHT}px` }}>
                    <div className="queueHeaderContents">
                        <h1 className="queueTitle" style={{ fontSize: '32px', marginBottom: '5px', width: '100%', textAlign: 'center' }} onClick={handleGoToFeed}>
                            Lava
                            <img className="queueTitleLogo" src={require('../../assets/images/logo-white.png')} />
                            amp
                        </h1>
                        <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '5px', width: '100%', justifyContent: 'center', gap: '15px' }}>
                            <button style={{ fontSize: '16px' }} className={`minimizeButton`} onClick={handleToggleAllMinimize}>{isAllMinimized ? 'Maximize All' : 'Minimize All'}</button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}